
/*프로젝트 최근 게시글 아이템 dom으로 변환하여 반환하는 함수*/
import {ttl2text} from "../../items/index.js";

export const getProjectPostsHtmByRecord = (allPostsArray) => {
    return allPostsArray && allPostsArray.map((item) => {
        item.COMMT_TTL = ttl2text(item.COMMT_TTL);
        return getProjectItem(item);
    }).join('');
}

/* 프로젝트 내부 글 아이템 단건으로 li 반환*/

export const getProjectItem = (item) => {
    const {
        COLABO_COMMT_SRNO,
        COLABO_SRNO,
        COLABO_REMARK_SRNO,
        READ_YN,
        TMPL_TYPE,
        COMMT_TTL
    } = item

    const tmplType = Often.null2Void(TMPL_TYPE, "1");
    const isRemark = tmplType === "-1";
    const post_gb = (isRemark ? "comment2 comment" : DetailCode.POST._GB[tmplType]);
    const not_read = ("N" === Often.null2Void(READ_YN, "N")) ? "alarm" : "";
    const tag2html = Mutil.tag2html(COMMT_TTL);

    return `<li id="allPosts-${COLABO_COMMT_SRNO}" colabo_srno="${COLABO_SRNO}" colabo_commt_srno="${COLABO_COMMT_SRNO}" colabo_remark_srno="${COLABO_REMARK_SRNO}" class="js-all-post-item">
                            <span class="article-icon-wrap ${not_read}"><i class="icons-${post_gb}"></i></span>
                            <p class="js-mouseover js-over-tooltip" mouseover-text="${tag2html}">${tag2html}</p>
                        </li>`
}
